import { InjectionToken } from '@angular/core';

export const LocalStorageKeysTypes = ['i18n'];
export const LOCAL_STORAGE_KEYS_TOKEN: InjectionToken<string[]> =
  new InjectionToken<string[]>('LocalStorageKeysToken', {
    providedIn: 'root',
    factory: () => LocalStorageKeysTypes,
  });

export const isLocalStorageKey =
  (allowedLocalStorageKeys: string[]) =>
  (key: string): boolean => {
    return allowedLocalStorageKeys.includes(key);
  };

export type LocalStorageState = {
  i18n: string | null;
  error: Error | null;
  isInitialized: boolean;
};

export const initialLocalStorageState: LocalStorageState = {
  i18n: null,
  error: null,
  isInitialized: false,
};
